import {useEffect, useState} from "react";
import * as React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import "./RegisterTrainingForm.css";
import {DialogContent, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography} from "@mui/material";

export type RegisterTrainingFormProps = {
    onPrevious: () => void;
    onNext: () => void;
};

const RegisterTrainingForm: React.FC<RegisterTrainingFormProps> = (props) => {
    const intl = useIntl();

    const [trainingNotices, setTrainingNotices] = useState(new Array());
    const [trainingSubjects, setTrainingSubjects] = useState(new Array());
    const [answerMap, setAnswerMap] = useState(new Map<string, string>());
    const [message, setMessage] = useState('');

    useEffect(() => {
        // 读取用户忽略列表
        fetch('/RegisterTrainingData.json')
            .then(response => response.json())
            .then((data) => {
                setTrainingNotices(data.notices);
                setTrainingSubjects(data.subjects);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const _handlePrevious = () => {
        props.onPrevious();
    }

    const _handleNext = () => {
        const nonAnswerSubjectIndex = [];
        let score = 0;
        const wrongAnswerSubjectIndex = [];
        for (let i = 0; i < trainingSubjects.length; i++) {
            if (answerMap.has(i.toString())) {
                const subject = trainingSubjects[i];
                const answer = answerMap.get(i.toString());
                if (answer === subject.answer) {
                    score = score + subject.score;
                } else {
                    wrongAnswerSubjectIndex.push(i + 1);
                }
            } else {
                nonAnswerSubjectIndex.push(i + 1);
            }
        }

        if (nonAnswerSubjectIndex.length > 0) {
            setMessage(intl.formatMessage({id: "VMS_REQUEST_VISITOR_TRAINING_NON_ANSWER"}) + nonAnswerSubjectIndex.join(","));
        } else {
            if (score < 80) {
                setMessage(intl.formatMessage({id: "VMS_REQUEST_VISITOR_TRAINING_SCORE_REQUIRED"}) + wrongAnswerSubjectIndex.join(","));
            } else {
                setMessage("");
                props.onNext();
            }
        }
    };

    const _handleClickAnswer = (value: string, index: number) => {
        answerMap.set(index.toString(), value);
        setAnswerMap(answerMap);
    }

    return (
        <div className={'mobile-register-training-container'}>
            {/*入厂安全须知*/}
            <Typography variant={'h5'} align={'center'}>入厂安全须知</Typography>
            <Typography variant={'h5'} align={'center'}>Safety instructions</Typography>
            {trainingNotices.map((item, index) => {
                return (
                    <div key={index} className={'mobile-register-training-panel'}>
                        <p>{index + 1}.{item.notice_zh}</p>
                        <p>{item.notice_en}</p>
                        <p>{item.image_url ? <img src={item.image_url}/> : ""}</p>
                    </div>
                )
            })}
            {/*测试部分*/}
            <Typography variant={'h5'} align={'center'}>测试/Test</Typography>
            <FormHelperText error={true}>
                请完成以下测试题（共20题。每题5分），您的得分在80分及以上，则表示您已经通过测试。
            </FormHelperText>
            <FormHelperText error={true}>
                Please complete the following test questions (20 in total, with 5 points per question). If your score is
                80 points or above, it means you have passed the test.
            </FormHelperText>
            {trainingSubjects.map((item, index) => {
                return (
                    <div key={index} className={'mobile-register-training-panel'}>
                        <p>{index + 1}.{item.subject_zh}</p>
                        <p>{item.subject_en}</p>
                        <RadioGroup row onChange={(e) => _handleClickAnswer(e.target.value, index)}>
                            <FormControlLabel value="true" control={<Radio/>} label="正确/True"/>
                            <FormControlLabel value="false" control={<Radio/>} label="错误/False"/>
                        </RadioGroup>
                    </div>
                )
            })}
            <FormHelperText error={true}>
                {message}
            </FormHelperText>
            <PreviousNextButton onPrevious={_handlePrevious} onNext={_handleNext}/>
        </div>
    )
};

export default RegisterTrainingForm;